import { render, staticRenderFns } from "./ModalCoordenadas.vue?vue&type=template&id=b63c911e&lang=pug"
import script from "./ModalCoordenadas.vue?vue&type=script&lang=js"
export * from "./ModalCoordenadas.vue?vue&type=script&lang=js"
import style0 from "./ModalCoordenadas.vue?vue&type=style&index=0&id=b63c911e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports